import React from 'react';
import CircularProgress from 'react-md/lib/Progress/CircularProgress';

import './LoadingSpinner.css'

const LoadingSpinner = ({ message }) => (
	<div className="loading-spinner-container">
		<div className="loading-spinner">
			<CircularProgress
				id="loading-spinner-circular-progress"
				key="progress"
				scale={3}
			/>
			<p>{ message }</p>
		</div>
	</div>
);

export default LoadingSpinner;


// WEBPACK FOOTER //
// ./src/components/common/LoadingSpinner.jsx